define('raw', function () {
    return {
        load: function (name, require, onload, config) {
            Cortona3DSolo.app.util.loadResource(require.toUrl(name), 'text/plain')
                .then(function (xhr) {
                    if (xhr.response) {
                        onload(xhr.response);
                    } else {
                        throw new Error(url + " empty content");
                    }
                })
                .catch(onload.error);
        }
    };
});